
export enum CustomerValueAddedServiceCode {
  LogisticsService= 'LogisticsService',
  ProvisionalLicensePlate= 'ProvisionalLicensePlate',
  VehicleNationalization= 'VehicleNationalization',
  VehicleRegistration= 'VehicleRegistration',
  PowertrainWarranty= 'PowertrainWarranty',
  FleequidCare= 'FleequidCare',

}